interface MonsterCardProps {
  id: string
  type: string
  health: string
  level: number
  imageUrl: string
}

export function MonsterCard({ id, type, health, level, imageUrl }: MonsterCardProps) {
  return (
    <div className="bg-white rounded-3xl p-6 border-2 border-purple-300">
      <div className="flex justify-between items-center mb-4">
        <span className="text-orange-500 font-bold text-xl">Leader</span>
        <div className="bg-purple-400 px-4 py-1 rounded-full text-white">#{id}</div>
        <span className="text-purple-400">Hunting: 04:59:20</span>
      </div>
      
      <div className="flex justify-center my-6">
        <img src={imageUrl} alt="Monster" className="w-32 h-32" />
      </div>
      
      <div className="flex justify-between gap-4 mt-4">
        <div className="bg-white border rounded-full px-6 py-1 text-center">
          {type}
        </div>
        <div className="bg-pink-400 rounded-full px-6 py-1 text-white">
          {health}
        </div>
        <div className="bg-white border rounded-full px-6 py-1 text-center">
          Lv {level}
        </div>
      </div>
    </div>
  )
}

